export default __webpack_public_path__ + "static/media/Hide.dad90feb.svg";